import { render, staticRenderFns } from "./StoreLog.vue?vue&type=template&id=5020f72d&scoped=true&"
import script from "./StoreLog.vue?vue&type=script&lang=js&"
export * from "./StoreLog.vue?vue&type=script&lang=js&"
import style0 from "./StoreLog.vue?vue&type=style&index=0&id=5020f72d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020f72d",
  null
  
)

export default component.exports